<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="page_13"><span class="txbf">List of Figures</span></a></h2><a id="page_13">
</a><p class="list"><a id="page_13"></a><a href="#/xhtml/ch02#ch2fig1">Figure 2-1 Ration Table</a></p>
<p class="list"><a href="#/xhtml/ch02#ch2fig2">Figure 2-2 Staple Food Pie Chart</a></p>
<p class="list"><span href="#/xhtml/ch03#ch3fig1" title="Link target outside of Sample">Figure 3-1 Boot Features</span></p>
<p class="list"><span href="#/xhtml/ch03#ch3fig2" title="Link target outside of Sample">Figure 3-2 Names for Fuel in Other Languages</span></p>
<p class="list"><span href="#/xhtml/ch03#ch3fig3" title="Link target outside of Sample">Figure 3-3 Temperature Ratings for Sleeping Bags</span></p>
<p class="list"><span href="#/xhtml/ch03#ch3fig4" title="Link target outside of Sample">Figure 3-4 Internal vs. External Frame Packs</span></p>
<p class="list"><span href="#/xhtml/ch03#ch3fig5" title="Link target outside of Sample">Figure 3-5 Pack Volume According to Use</span></p>
<p class="list"><span href="#/xhtml/ch04#ch4fig1" title="Link target outside of Sample">Figure 4-1 The Economical Wardrobe</span></p>
<p class="list"><span href="#/xhtml/ch05#ch5fig1" title="Link target outside of Sample">Figure 5-1 Number of Backpackers Age 16 and Older</span></p>
<p class="list"><span href="#/xhtml/ch05#ch5fig2" title="Link target outside of Sample">Figure 5-2 National Park Recreational Visits 1926-1996</span></p>
<p class="list"><span href="#/xhtml/ch05#ch5fig3" title="Link target outside of Sample">Figure 5-3 Camping Surfaces</span></p>
<p class="list"><span href="#/xhtml/ch06#ch6fig1" title="Link target outside of Sample">Figure 6-1 Water Loss as a Percentage of Body Weight Related to Performance and Symptoms</span></p>
<p class="list"><span href="#/xhtml/ch06#ch6fig2" title="Link target outside of Sample">Figure 6-2 Recommended Daily Water Intake According to Weight</span></p>
<p class="lista"><span href="#/xhtml/ch10#ch10fig1" title="Link target outside of Sample">Figure 10-1 Cloud Types</span></p>
<p class="lista"><span href="#/xhtml/ch11#ch11fig1" title="Link target outside of Sample">Figure 11-1 The Six Most Common Food-Borne Illnesses</span><a id="page_14"></a></p><a id="page_14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?1884419f